import axios from 'axios';
import { IAusgabe } from '@/shared/model/ausgabe.model';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
const baseApiUrl = 'api/ausgabe';

export default class AusgabeService {
  public retrieveReco(): Promise<any> {
    return axios.get(`${baseApiUrl}Reco`);
  }

  public retrieve(req?: any): Promise<any> {
    return axios.get(`${baseApiUrl}?${buildPaginationQueryOpts(req)}`);
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public find(id: number): Promise<IAusgabe> {
    return new Promise<IAusgabe>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IAusgabe): Promise<IAusgabe> {
    return new Promise<IAusgabe>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IAusgabe): Promise<IAusgabe> {
    return new Promise<IAusgabe>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
